<script>
import {mapGetters, mapState} from "vuex";
import Tile from '@/components/tile.vue';
import planCommon from './mixin';
import {BILLING_CYCLE} from "@/common/constants";
import base from '@/views/config/addon-cards/templates/base.vue';
import {
  computedActiveUnlimitedCallingPlans,
  computedCallingPlans,
  computedPbxCallingPlans,
  computedPbxPlans,
} from '@/common/service/computers/plans/pbx';
import store from '@/store';
import { isBizPlusContext, isProPlusContext } from '../ZOOM_MEETING/common/utils';
import ZoomPhoneInternationalCallingLogo from '@/assets/plans/zoom_phone_international_calling.svg';

export default {
  name: 'ZoomPhoneInternationalAddOn',
  mixins: [base, planCommon],
  components: {
    Tile,
  },
  for: () => {
    if(isProPlusContext) return true;
    if(isBizPlusContext) return false;
    const mergePlanList = store.getters.getUserCurrentSubscriptions;
    const pbxUnlimitedPlans = computedActiveUnlimitedCallingPlans(mergePlanList);
    return pbxUnlimitedPlans.length;
  },
  created() {
    if(this.defaultPlan) {
      const { amount, billing_cycle } = this.defaultPlan;
      this.subtitle = this.$money(amount) + this.$t(`billing.common.per_billing_cycle_license.${billing_cycle}`);
    }
  },

  data() {
    return {
      logo: ZoomPhoneInternationalCallingLogo,
    };
  },

  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters({
      getSelectedPlans: 'getSelectedPlans',
      getUserCurrentSubscriptions: 'getUserCurrentSubscriptions'
    }),
    callingPlanType() {
      const callingPlan = computedPbxCallingPlans(this.getSelectedPlans)[0];
      if(callingPlan) {
        return callingPlan.sub_type;
      }
      return '';
    },
    currentBillingCycle() {
      const selectCallingPlan = computedCallingPlans(this.getUserCurrentSubscriptions)[0];
      if(selectCallingPlan) {
        return selectCallingPlan.billing_cycle;
      }
      return BILLING_CYCLE.ANNUAL;
    },
    defaultPlan() {
      return computedPbxPlans(this.planMapFlat)
      .filter(item => item.category === 'ZPI')
      .find(item => item.billing_cycle === this.currentBillingCycle);
    },
  },
  methods: {
    addOn() {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      document.addPlanFromEnterKey = true;
      this.$emit('add', this.$options?.key);
      this.$tracking.addOnBuyInteraction('zoom phone add-ons', `${this.title?.toLowerCase()} - add`);
    },
  },
  watch: {
    defaultPlan(value) {
      if(value) {
        const { amount, billing_cycle } = value;
        this.subtitle = this.$money(amount) + this.$t(`billing.common.per_billing_cycle_license.${billing_cycle}`);
      }
    },
  },
};
</script>
